import clsx from "clsx";
import Styles from "./index.module.scss";
import { ModalInput } from "../../Atoms/InputModal";
import { SelectModal } from "../../Atoms/SelectModal";
import { Controller } from "react-hook-form";
import { Button } from "react-bootstrap";
import { FaPlusSquare } from "react-icons/fa";
import { FaRegTrashAlt } from "react-icons/fa";
import { useAddItemForm } from "../../../Hooks/useAddItemForm";

export default function AddItemForm({ user, handleCloseKnbModal, items }) {
  const {
    control,
    handleSubmit,
    selectedType,
    getUniqueTypes,
    filterItemsByType,
    handleItemChange,
    handleTypeChange,
    gameItems,
    handleAddGameItem,
    handleRemoveGameItem,
  } = useAddItemForm({ user, handleCloseKnbModal, items });

  return (
    <div className={clsx(Styles.container)}>
      <form className={clsx(Styles.itemForm)} onSubmit={handleSubmit}>
        <div className={clsx(Styles.gameItems)}>
          <div className={clsx(Styles.header)}>
            <h5>Vật phẩm</h5>
            {!gameItems.length && (
              <Button
                className={clsx(Styles.btnItemAdd)}
                onClick={handleAddGameItem}
              >
                <FaPlusSquare /> Thêm
              </Button>
            )}
          </div>
          {gameItems.length && (
            <>
              <div className={clsx(Styles.itemComponents)}>
                <div className={clsx(Styles.item)}>
                  <SelectModal
                    label="Loại"
                    id="type"
                    onChange={handleTypeChange}
                    options={getUniqueTypes()}
                    value={selectedType}
                  />
                </div>
                <div className={clsx(Styles.item)}>
                  <Controller
                    name="gameItems.0.id"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <SelectModal
                        label="Tên"
                        id="type"
                        onChange={(e) => handleItemChange(e, field.onChange)}
                        error={error}
                        options={filterItemsByType(selectedType).map(
                          (item) => ({
                            value: item.Id,
                            label: item.Name,
                          })
                        )}
                        value={field.value}
                      />
                    )}
                  />
                </div>
              </div>
              <div className={clsx(Styles.itemComponents)}>
                <div className={clsx(Styles.item)}>
                  <Controller
                    name="gameItems.0.quantity"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <ModalInput
                        id={"quantity"}
                        label="Số lượng"
                        value={field.value}
                        onChange={field.onChange}
                        error={error}
                      />
                    )}
                  />
                </div>

                <div className={clsx(Styles.item)}>
                  <Controller
                    name="gameItems.0.duration"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <ModalInput
                        id={"duration"}
                        label="Thời hạn"
                        value={field.value}
                        onChange={field.onChange}
                        error={error}
                      />
                    )}
                  />
                </div>
              </div>
              <div className={clsx(Styles.itemAction)}>
                <Button
                  className={clsx(Styles.btnItemDelete)}
                  onClick={handleRemoveGameItem}
                >
                  <FaRegTrashAlt /> Xóa
                </Button>
                <Button
                  variant="success"
                  className={clsx(Styles.button)}
                  type="submit"
                >
                  Cập nhật
                </Button>
              </div>
            </>
          )}
        </div>
      </form>
    </div>
  );
}
